import styled from 'styled-components';
import { colors } from '@prenuvo/shared-library';
import { Label as LayoutLabel } from '../Layout';

interface LabelProps {
  incomplete?: boolean;
}

export const Label = styled(LayoutLabel)<LabelProps>`
  ${({ incomplete }) =>
    incomplete &&
    `
    &:after {
      content: '*';
      color: ${colors.secondary};
    }
  `}
`;

export const List = styled.ul`
  margin: 0;
  padding-left: 20px;
  list-style-type: disc;

  li {
    font-size: 14px;
    color: ${colors.ash};
    line-height: 1.5;
  }
`;

export const ListItem = styled.li`
  margin-bottom: 4px;
  font-size: 14px;
  color: ${colors.ash};
  line-height: 1.5;
`;

export const FlexibleGrid = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 16px;

  @media (max-width: 768px) {
    flex-direction: column;
  }
`;

export const GridColumn = styled.div`
  flex: 0 0 calc(33.333% - 11px); /* Fixed width, no grow/shrink */
  min-width: 250px;
  margin-bottom: 16px;

  @media (max-width: 768px) {
    flex: 1 1 100%;
    min-width: auto;
  }
`;
